import classNames from 'classnames'
import React from 'react'
import { Close } from 'wujieai-react-icon'
import { MyImage } from '~/components/ui/MyImage'
interface IProps {
  list: Array<any>
  setFileList: React.Dispatch<React.SetStateAction<any[]>>
}
const FileList: React.FC<IProps> = ({ list, setFileList }) => {
  return (
    <div className="flex overflow-auto scrollbar-hidden mb-2 pt-2 -mt-2 select-none">
      {list?.map((it, i) => (
        <div
          key={i}
          className="flex justify-between items-center bg-neutral-300 px-2 py-1 mr-2.5 relative rounded-lg"
        >
          <div
            className={classNames(
              'absolute right-0 -top-1.5 w-3 h-3 rounded-full flex justify-center items-center',
              'text-white border border-white bg-neutral-400 cursor-pointer'
            )}
            style={{ boxShadow: `0px 3px 6px 0px rgba(0, 0, 0, 0.08)` }}
            onClick={() => {
              setFileList(list.filter((_, idx) => idx !== i))
            }}
          >
            <Close size={8} />
          </div>
          <div className="flex-shrink-0 w-8 h-8 flex justify-center items-center bg-neutral-400 rounded mr-2 overflow-hidden">
            {it.status === 'pending' ? (
              <MyImage
                src={'/images/deepseek/loading.png'}
                className="w-[14px] h-[14px] leading-none block animate-spin origin-center"
              />
            ) : (
              <MyImage
                src={it.url}
                className="w-8 h-8 leading-none block origin-center"
                tag="v800"
              />
            )}
          </div>
          <div className="text-xs font-bold text-neutral-400 overflow-hidden w-[88px]">
            <h3 className="text-sm text-white line-clamp-1">{it.fileName}</h3>
            <div>{it.status === 'pending' ? '等待中' : it.fileSize}</div>
          </div>
        </div>
      ))}
    </div>
  )
}
export default FileList
